import React from 'react';

import { SectionTitle, SEOText } from '@/ui/index';

import Step from './Step';

import styles from './InternetActivation.module.scss';

const InternetActivation = ({ data }) => {
  const renderStep = (step, key) => <Step step={step} key={key} />;

  return (
    <div
      className={'wrapper section'}
      itemScope
      itemType='http://schema.org/Service'
    >
      <SectionTitle className={styles.title}>{data?.title}</SectionTitle>
      {data?.top_content && (
        <SEOText className={styles.text}>{data.top_content}</SEOText>
      )}
      {!!data?.steps && (
        <div className={styles.videoSlider}>
          <div className={`${styles.steps} grid-extend ${styles.steps}`}>
            {data.steps.map(renderStep)}
          </div>
        </div>
      )}
      {data?.bottom_content && (
        <SEOText className={styles.text}>{data.bottom_content}</SEOText>
      )}
    </div>
  );
};

export default InternetActivation;
